/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef } from 'react';
import { Button } from '@material-ui/core';
import ReactHlsPlayer from 'react-hls-player';
import { useHistory } from 'react-router-dom';

import { CeremonySelectionProps } from './CeremonySelection.types';
import { useStyles } from './CeremonySelection.styles';
import { AppRoute } from 'app/routing/AppRoute.enum';

export const CeremonySelection = ({
  activeStep,
  setActiveStep,
  setPausedTime,
  streamURL,
  participantId,
  setIsFromCeremony,
}: CeremonySelectionProps) => {
  const styles = useStyles();
  const videoRef = useRef<HTMLVideoElement | null>(null); // Correct type
  const { push } = useHistory();

  // Function to handle video pause and capture the current time
  // const handlePause = () => {
  //   const video = videoRef.current;

  //   if (video) {
  //     const { currentTime } = video;
  //     setPausedTime(currentTime); // Capture the paused time
  //   }
  // };

  const handleSnackBarClose = () => {
    const video = videoRef.current;

    if (video) {
      const pausedTime = video.currentTime; // Get the paused time
      const timeInSeconds = Math.floor(Number(pausedTime)); // Converts directly to whole seconds

      setPausedTime(timeInSeconds); // Pass paused time to parent
    }
    setIsFromCeremony(true);
    setActiveStep(activeStep + 1);
  };

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <ReactHlsPlayer
            playerRef={videoRef}
            src={streamURL}
            preload="metadata"
            // width="1000px"
            height="100%"
            controlsList="nodownload"
            disablePictureInPicture
            controls
            playsInline
            // onPause={handlePause}
            autoPlay={false}
            className={styles.hlsPlayer}
          />
        </div>
        <div className={styles.buttonContainer}>
          <Button
            className={styles.backButton}
            onClick={() =>
              push(`${AppRoute.participantSelection.replace(':participantId', participantId)}?isItemMatched=true`)
            }
          >
            Home
          </Button>
          <Button
            className={styles.confirmButton}
            onClick={() => {
              handleSnackBarClose();
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};
